import { render, staticRenderFns } from "./normal-home.vue?vue&type=template&id=b73791d8&scoped=true"
import script from "./normal-home.vue?vue&type=script&lang=js"
export * from "./normal-home.vue?vue&type=script&lang=js"
import style0 from "./normal-home.vue?vue&type=style&index=0&id=b73791d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73791d8",
  null
  
)

export default component.exports